var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('app-header'),(_vm.isLoading)?_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"spinner spinner-1"})]):_vm._e(),_c('router-view'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }